export enum enumTipoFluxoProposta {
    FLUXO_PARCERIA = "PARCERIAS",
    FLUXO_TRADICIONAL = "TRADICIONAL",
}